import {MenuUidVo} from '../../common/shared/api/gateway/enums/MenuUidVo.enum';
import {ShortcutMenuItem} from '../generated/types';
import {createShortcutHomeType} from './ShortcutHomeType';

export function createShortcutMenuItem(menu_uid: MenuUidVo): ShortcutMenuItem {
  return {
    shortcutHomeType: createShortcutHomeType(menu_uid),
    shortcutHomeUrl: `/menu/${menu_uid}`,
  };
}
